// Icons exported from the job detail frame (Figma 3820:20288). These are drawn
// at different sizes from the careers listing set, so they are separate files
// rather than rescaled copies.
import { ReactComponent as ArrowLeft } from "./images/arrow-left.svg";
import { ReactComponent as BadgeCheck } from "./images/badge-check-20.svg";
import { ReactComponent as Briefcase } from "./images/briefcase-20.svg";
import { ReactComponent as CheckCircle } from "./images/check-circle-18.svg";
import { ReactComponent as MapPin } from "./images/map-pin-20.svg";
import { ReactComponent as Users } from "./images/users-20.svg";

export const glanceIcons = {
    mapPin: MapPin,
    briefcase: Briefcase,
    badgeCheck: BadgeCheck,
    users: Users,
};

export { ArrowLeft, CheckCircle };
